// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { Status } from './status';


export class GeneralStatusMessage implements flatbuffers.IUnpackableObject<GeneralStatusMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):GeneralStatusMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsGeneralStatusMessage(bb:flatbuffers.ByteBuffer, obj?:GeneralStatusMessage):GeneralStatusMessage {
  return (obj || new GeneralStatusMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsGeneralStatusMessage(bb:flatbuffers.ByteBuffer, obj?:GeneralStatusMessage):GeneralStatusMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new GeneralStatusMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

message():Status {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : Status.HighSpeedStartSequence;
}

static startGeneralStatusMessage(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addMessage(builder:flatbuffers.Builder, message:Status) {
  builder.addFieldInt16(0, message, Status.HighSpeedStartSequence);
}

static endGeneralStatusMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createGeneralStatusMessage(builder:flatbuffers.Builder, message:Status):flatbuffers.Offset {
  GeneralStatusMessage.startGeneralStatusMessage(builder);
  GeneralStatusMessage.addMessage(builder, message);
  return GeneralStatusMessage.endGeneralStatusMessage(builder);
}

unpack(): GeneralStatusMessageT {
  return new GeneralStatusMessageT(
    this.message()
  );
}


unpackTo(_o: GeneralStatusMessageT): void {
  _o.message = this.message();
}



unpackFields(...fields: string[]): GeneralStatusMessageT {
  const t = new GeneralStatusMessageT();
  const fieldSet = new Set(fields);
  if (fieldSet.has('message')) {
    t.message = this.message();
  }
  return t;
}
}

export class GeneralStatusMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public message: Status = Status.HighSpeedStartSequence
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return GeneralStatusMessage.createGeneralStatusMessage(builder,
    this.message
  );
}

clone(): GeneralStatusMessageT {
  const obj = new GeneralStatusMessageT();
  obj.message = this.message;
  return obj;
}

equals(other: GeneralStatusMessageT): boolean {
  if (this.message !== other.message) return false;
  return true;
}
}

export function verifyGeneralStatusMessage(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 2);
  } finally {
    verifier.popDepth();
  }
}
